import script from "./RobotReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./RobotReview.vue?vue&type=script&setup=true&lang=ts"

import "./RobotReview.vue?vue&type=style&index=0&id=0f0e18b4&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f0e18b4"]])

export default __exports__